import { render, staticRenderFns } from "./SettingButton.vue?vue&type=template&id=b62c13d8"
import script from "./SettingButton.vue?vue&type=script&lang=js"
export * from "./SettingButton.vue?vue&type=script&lang=js"
import style0 from "./SettingButton.vue?vue&type=style&index=0&id=b62c13d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports